import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

/**
 * DeepLinkBackButton
 *
 * Reads `?back=<url>` and `?back_label=<text>` from the current URL.
 * Renders a sticky "← Back to <label>" button if `back` is present.
 * On click, navigates to the back URL (preserving any query string therein).
 *
 * Drop this at the top of any landing page that's reached via deep-link from
 * elsewhere (e.g. SO-grouped fulfillment view → WorkOrderPage / IndentRegister /
 * PurchaseOrders).
 */
export default function DeepLinkBackButton() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const backUrl = searchParams.get('back');
  const backLabel = searchParams.get('back_label') || 'Back';

  if (!backUrl) return null;

  let decoded;
  try {
    decoded = decodeURIComponent(backUrl);
  } catch {
    return null;
  }

  return (
    <div className="mb-3" data-testid="deep-link-back-bar">
      <Button
        variant="outline"
        size="sm"
        className="text-sm h-8"
        onClick={() => navigate(decoded)}
        data-testid="btn-deep-link-back"
      >
        <ArrowLeft size={14} className="mr-1" />
        Back to {backLabel}
      </Button>
    </div>
  );
}
